import React, { useEffect } from "react";
import Nav from "../Nav";
import AOS from "aos";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import "aos/dist/aos.css";
import certificate from "../Home/details/components/Images/certificate.png";
import { motion } from "framer-motion";
import "./about.css";
import banner from "./banner2.jpg";
import BenefitsSection from "./Benefits";

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      delay: 390,
    });
  }, []);

  return (
    <>
      <Nav />
      <Box
        // sx={{
        //   backgroundColor: "#FAFAFA",
        //   py: 5,
        //   fontFamily: "Arial, sans-serif",
        // }}
      >
        {/* <Box
          sx={{
            // backgroundImage: `url(${banner})`,
            py: 10,
            textAlign: "center",
            color: "#ffffff",
          }}
        >
          <Container maxWidth="md">
            <Typography
              className="merriweather-bold"
              variant="h2"
              align="center"
              gutterBottom
              sx={{ fontWeight: "bold", fontFamily: "Arial, sans-serif" }}
            >
              About Us
            </Typography>
          </Container>
        </Box> */}
        <Container
          maxWidth="lg"
          sx={{ backgroundColor: "#ffffff", p: 5, borderRadius: 2, mt: -8 }}
        >
          <section className="relative p-8 md:p-12 bg-blue-300 rounded-[35px] h-auto shadow-md mt-64">
            {/* Profile Image Positioned at Top-Left */}
            <img
              src="newimage/about/2 - Rade's Profile Picture.jpg"
              alt="Profile"
              className="absolute top-[-50px] left-1/2 transform -translate-x-1/2 md:top-[-60px] md:left-[-50px] md:translate-x-0 w-40 h-40 md:w-52 md:h-52 rounded-full border-4 border-white shadow-lg"
            />

            <div className="mt-24 md:ml-36 md:mt-0 text-center md:text-left">
              {/* Increased left margin on larger screens, centered text on small screens */}
              <h2 className="text-xl md:text-2xl font-semibold text-gray-50 mb-6 md:mb-8 md:mt-[-26px]">
                Hello fellow learners! Thanks for dropping by!
                <h6 className="text-sm md:text-base">
                  Let me ask you a few questions:
                </h6>
              </h2>

              <ul className="list-disc pl-6 md:pl-10 text-gray-100 text-sm md:text-base leading-relaxed">
                <li>Do you feel confident when you speak English?</li>
                <li>
                  Can you express your thoughts and ideas easily in English?
                </li>
                <li>Do you need to speak English at work?</li>
                <li>Can you hear native speakers when they speak?</li>
                <li>
                  Do you ever feel like people are speaking too fast in English?
                </li>
                <li>
                  If you're nodding along, you're not alone. Breaking the
                  language barrier doesn't come easy, but where there's a will,
                  there's a way!
                </li>
              </ul>
            </div>
          </section>

          <section className=" py-12 px-6 md:px-16 w-auto">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
              {/* Left Side - Story Content */}
              <div className="md:w-3/5 w-full">
                <div className="bg-gray-800 text-white text-lg font-semibold px-9 py-2 inline-block rounded-3xl">
                  Here's my story:
                </div>
                <p className="mt-1 text-gray-700 leading-relaxed">
                  Growing up in Yugoslavia was serene until conflict changed
                  everything. Surrounded by native English speakers during UN
                  peacekeeping, I soaked up the language like a sponge.
                </p>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  Now, after 25 years of using English daily, it's my passion
                  and a part of my life, and not a job. Working with the United
                  Nations for eight years as a translator and interpreter was a
                  life-changing experience. But each challenge taught me
                  something new, making it a colorful period of growth and
                  learning. I decided to apply a famous phrase in my life and
                  feel immensely happy about it - “Find a job you love, and you
                  will never have to work a day in your life.”
                </p>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  Finally, obtaining the UN LPE Certificate in 2004 was a proud
                  moment for me and a logical step after spending quite some
                  time with the United Nations. You see, in my case, English
                  isn't just a language but a bridge between cultures that
                  opened doors to many opportunities in my life.
                </p>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  As a result, speaking English has exposed me to diverse
                  cultures, enriching my life beyond measure. It has been my
                  passion from the start, facilitating connections and enriching
                  my life experience beyond my wildest expectations.
                </p>
                <p className="mt-4 text-gray-700 leading-relaxed">
                  This remains true for me even now, as continue to communicate
                  with people from all over the world daily. Not only do I teach
                  them English, but they also share so much with me about their
                  countries, cultures, and history. I am so grateful for this
                  opportunity and appreciate it very much.
                </p>
                <p className=" w-full mt-4 text-gray-700 leading-relaxed ">
                  If you're passionate about speaking English, I encourage you
                  to join me on this fascinating journey. Whether you're at the
                  beginning of your adventure or well on your way, there's
                  always something new to learn and explore.
                </p>
              </div>

              {/* Right Side - Certificate Image */}
              <div className="md:w-2/5">
                <img
                  src={certificate}
                  alt="Language Proficiency Certificate"
                  className="w-full rounded-[35px] "
                />
              </div>
            </div>
          </section>

          <BenefitsSection />
        </Container>
      </Box>
    </>
  );
};

export default About;
